<template>
    <div class="iChat-session-footer">
        <div class="iChat-message-form" :class="{'focus-form':text!==''||isFocus}">
            <div class="iChat-voice-btn">
                <img src="@/assets/instantMessaging/ic_voice.svg">
            </div>
            <div class="iChat-input-warp">
                <input type="text"
                    @focus="isFocus = true"
                    @keypress.enter="sendTextMessage(text)"
                    @focusout="isFocus = false"
                    class="iChat-message-input"
                    v-model="text">
            </div>
            <div class="iChat-send-warp">
                <img src="@/assets/instantMessaging/ic_emoji.svg"
                    class="iChat-icon"
                    @click.stop="toggleExpression"/>
                <img src="@/assets/instantMessaging/ic_toolbar.svg"
                    v-show="text===''"
                    @click.stop="toggleTool"
                    class="iChat-icon"/>
                <button class="iChat-send-btn"
                    style="display: none"
                    v-show="text!==''"
                    @touchend.prevent="sendTextMessage(text)">发送</button>
            </div>
        </div>
        <div class="iChat-expression-panel scroll" v-show="isShowExpression">
            <ul class="expression-list">
                <li v-for="item in expressions"
                    :key="item.title"
                    @click.stop="pickerExpression(item)">
                    <img :src="require('../../../assets/instantMessaging/qq' + item.url)" alt="">
                </li>
            </ul>
        </div>
        <div class="iChat-tool-panel scroll" v-show="isShowTool">
            <ul class="iChat-tool-list" @click.stop="">
                <!-- 单聊或者一机管的群聊 -->
                <template v-if="isC2C">
                    <li>
                        <label class="iChat-tool-item">
                            <img class="icon-img" src="@/assets/instantMessaging/ic_picture.svg" />
                            <span class="item-text">照片</span>
                            <input type="file" accept="image/*"
                                ref="imagePicker"
                                @change="sendImage">
                        </label>
                    </li>
                    <li>
                        <label class="iChat-tool-item">
                            <img class="icon-img" src="@/assets/instantMessaging/ic_files.svg" />
                            <span class="item-text">文档</span>
                            <input type="file" ref="filePicker" @change="sendFile">
                        </label>
                    </li>
                    <li v-if="!isPersonalChat">
                        <label :class="[
                            'iChat-tool-item',
                            {
                                'disable-text': isEvaluation
                            }
                        ]" @click="inviteEvaluationHandle">
                            <img class="icon-img" src="@/assets/instantMessaging/ic_invite.svg" />
                            <span class="item-text">邀请评价</span>
                        </label>
                    </li>
                    <li @click="reportHandle">
                        <label class="iChat-tool-item">
                            <div class="report-img-box">
                                <img src="@/assets/instantMessaging/report.png" />
                            </div>
                            <span class="item-text C_item-text">举报</span>
                        </label>
                    </li>
                       <li @click="inviteToJoin">
                        <label class="iChat-tool-item">
                            <div class="joinBox">
                                <img class="icon-img" src="@/assets/instantMessaging/inviteToJoin.png" />
                            </div>
                            <span class="item-text">邀请加入</span>
                        </label>
                    </li>
                </template>
                  <template v-else-if="currentUserRole === 'custom'">
                    <li>
                        <label class="iChat-tool-item">
                            <img class="icon-img" src="@/assets/instantMessaging/icon_picture.svg" />
                            <span class="item-text C_item-text">照片</span>
                            <input type="file" accept="image/*"
                                ref="imagePicker"
                                @change="sendImage">
                        </label>
                    </li>
                    <li>
                        <label class="iChat-tool-item">
                            <img class="icon-img" src="@/assets/instantMessaging/icon_files.svg" />
                            <span class="item-text C_item-text">文档</span>
                            <input type="file" ref="filePicker" @change="sendFile">
                        </label>
                    </li>
             
                </template>

                <template v-else>
                    <li>
                        <label class="iChat-tool-item">
                            <img class="icon-img" src="@/assets/instantMessaging/ic_picture.svg" />
                            <span class="item-text">照片</span>
                            <input type="file" accept="image/*"
                                ref="imagePicker"
                                @change="sendImage">
                        </label>
                    </li>
                    <li>
                        <label class="iChat-tool-item">
                            <img class="icon-img" src="@/assets/instantMessaging/ic_files.svg" />
                            <span class="item-text">文档</span>
                            <input type="file" ref="filePicker" @change="sendFile">
                        </label>
                    </li>
                    <li v-if="!isPersonalChat">
                        <label :class="[
                            'iChat-tool-item',
                            {
                                'disable-text': isEvaluation
                            }
                        ]" @click="inviteEvaluationHandle">
                            <img class="icon-img" src="@/assets/instantMessaging/ic_invite.svg" />
                            <span class="item-text">邀请评价</span>
                        </label>
                    </li>
                    <!-- <li @click="reportHandle">
                        <label class="iChat-tool-item">
                            <div class="report-img-box">
                                <img src="@/assets/instantMessaging/report.png" />
                            </div>
                            <span class="item-text C_item-text">举报</span>
                        </label>
                    </li>
                     <li @click="inviteToJoin">
                        <label class="iChat-tool-item">
                            <div class="joinBox">
                                <img class="icon-img" src="@/assets/instantMessaging/inviteToJoin.png" />
                            </div>
                            <span class="item-text">邀请加入</span>
                        </label>
                    </li> -->
             
                </template>


            </ul>
        </div>
    </div>
</template>

<script>
	import { eventBus } from '@/main';
    import { mapGetters, mapMutations, mapState } from 'vuex';
	import expressions from '../data/expressions';
	import api from '@/service/modules/instantMessaging';

	export default {
		name: "chatFooter",
		props: {
			modelValue: {type: String, default: ''},
            isPersonalChat: {type: Boolean, default: false}
		},
		data() {
			return {
                isFocus: false,
                isShowExpression: false,
                isShowTool: false,
                expressions: expressions,
                text: "",
				isEvaluation: false
			};
		},
		computed: {
            ...mapGetters('instantMessaging', [
                'currentConversationType',
                'toAccount',
                'isCustom',
                'isC2C'
            ]),
            ...mapState('instantMessaging', [
	            'currentConversation',
	            'currentUserProfile',
                'isCustom',
                'currentUserRole'
            ])
		},
		mounted() {
            console.log('是否是isC2C啊啊啊啊啊啊啊',this.isC2C );
            console.log('isPersonalChat11111111111111111',this.isPersonalChat);
            

			document.addEventListener("click", (e) => {
				this.isShowExpression = false;
				this.isShowTool = false;
			});
			this.getEvaluation(100);
		},
		methods: {
            ...mapMutations('instantMessaging', [
                'pushCurrentMessageList',
                'showMessage'
            ]),
           inviteToJoin() {
                this.$router.push({
                    path: '/selectContact',
                    query: {
                    }
                })
            },
            // 举报
            reportHandle() {
                this.$router.push('/report')
            },
			toggleExpression() {
				this.isShowExpression = !this.isShowExpression;
				this.isShowTool = false;
			},
			pickerExpression(item) {
				this.text += item.title;
			},
			fileChange(e) {
			    console.log(e);
			},
			sendImage(event) {
				const message = this.tim.createImageMessage({
					to: this.toAccount,
					conversationType: this.currentConversationType,
					payload: {
						file: event.target // 或者用event.target
					},
					onProgress: percent => {
						this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
					}
				});
				this.pushCurrentMessageList(message);
				this.$bus.$emit('scroll-bottom');
				this.tim.sendMessage(message).then(() => {
					this.$refs.imagePicker.value = null;
				}).catch(error => {
					this.showMessage({
						type: 'danger',
						message: error.message
					})
				})
			},
			sendTextMessage() {
				if (this.text === '' || this.text.trim().length === 0) {
					this.text = '';
					this.showMessage({
						message: '不能发送空消息哦！',
						type: 'primary'
					});
					return
				}
                console.log('有toAccount么么么么么么么木木木木木木木木木', this.toAccount);
                console.log('有currentConversationType么么么么么么么木木木木木木木木木', this.currentConversationType);
                
				const message = this.tim.createTextMessage({
					to: this.toAccount,
					conversationType: this.currentConversationType,
					payload: { text: this.text }
				});
				this.pushCurrentMessageList(message);
				this.$bus.$emit('scroll-bottom');
				this.tim.sendMessage(message).catch(error => {
					this.showMessage({
						type: 'danger',
						message: error.message
					})
				});
				this.text = ''
			},
			sendFile(event) {
				const message = this.tim.createFileMessage({
					to: this.toAccount,
					conversationType: this.currentConversationType,
					payload: {
						file: event.target // 或者用event.target
					},
					onProgress: percent => {
						this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
					}
				});
				this.pushCurrentMessageList(message);
				this.$bus.$emit('scroll-bottom');
				this.tim.sendMessage(message).then(() => {
                    this.$refs.filePicker.value = null;
                }).catch(imError => {
                    this.showMessage({
                        message: imError.message,
                        type: 'danger'
                    })
                })
			},
			toggleTool() {
				this.isShowTool = !this.isShowTool;
				this.isShowExpression = false;
			},
			async inviteEvaluationHandle () {
			    if (this.isEvaluation) {
			        return this.showMessage({
				        type: 'danger',
				        message: '请勿重复邀请'
			        })
			    }
	            let res = await api.preEvaluate({
		            targetId: this.currentUserProfile.userID,
		            groupId: this.toAccount
	            });
	            if (res.errorcode !== 0) {
	                return this.showMessage({
		                type: 'danger',
		                message: res.msg
	                })
	            }
	            if (res.data) {
	                this.isEvaluation = true;
	            }
	            const message = this.tim.createCustomMessage({
		            to: this.toAccount,
		            conversationType: this.currentConversationType,
		            payload: {
		                data: 'EVALUATE',
		                description: JSON.stringify({
		                    userId: this.currentUserProfile.userID,
		                    groupId: this.toAccount
		                }),
		                extension: ''
                    }
	            });
				this.pushCurrentMessageList(message);
				this.$bus.$emit('scroll-bottom');
				this.tim.sendMessage(message).catch(error => {
					this.showMessage({
						type: 'danger',
						message: error.message
					})
				});
            },
            getEvaluation(time) {
                if (this.isCustom || this.isC2C) {
                    return false;
                }
                if (!this.currentUserProfile || !this.toAccount)  {
	                return setTimeout(() => {
		                this.getEvaluation(time);
	                }, time)
                }
                api.getEvaluate({
	                targetId: this.currentUserProfile.userID,
	                groupId: this.toAccount
                }).then(res => {
                    if (res.data) {
	                    this.isEvaluation = true;
                    }
                })
            }
		},

	}
</script>

<style scoped lang="less">
    .iChat-session-footer {
        /*position: absolute;*/
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 10;
        /* 适配底部黑条*/
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }

    .iChat-message-form {
        padding: 12px 12px 16px;
        background-color: #fff;
        display: flex;

        .iChat-voice-btn {
            width: 32px;
            height: 32px;
            margin-right: 4px;
        }

        .iChat-input-warp {
            margin-right: 4px;
            flex: 1;
            transition: all .2s;

            .iChat-message-input {
                display: block;
                box-sizing: border-box;
                line-height: 30px;
                font-size: 14px;
                color: #7d8085;
                width: 100%;
                padding: 0;
                margin: 0;
                border: none;
                outline: none;
                background-color: #F9FAFC;
            }
        }

        // .iChat-message-input:focus {
        //     border-bottom: 1px solid #67c23a;
        // }

        .iChat-send-warp {
            display: flex;
            transition: all .2s;

            .iChat-icon {
                width: 32px;
                height: 32px;
            }

            .iChat-icon + .iChat-icon {
                margin-left: 4px;
            }

            .iChat-send-btn {
                display: inline-block;
                width: 100%;
                text-align: center;
                line-height: 14px;
                padding: 9px 10px;
                font-size: 14px;
                background-color: rgb(54, 179, 116);
                border-radius: 4px;
                border: none;
                outline: none;
                color: #fff;
                vertical-align: middle;
                margin-left: 4px;
            }
        }
    }

    .iChat-expression-panel {
        height: 160px;
        overflow-y: auto;
        background-color: #fff;

        .expression-list {
            list-style: none;
            padding: 0 5px;
            margin: 0;

            li {
                float: left;
                width: 30px;
                height: 30px;
                padding: 5px;

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .iChat-tool-panel {
        // height: 123px;
        overflow-y: auto;
        background-color: #fff;

        .iChat-tool-list {
            list-style: none;
            padding: 10px 17px;
            display: flex;
            margin: 0;
            flex-wrap: wrap;

            li:nth-of-type(4n) {
                margin-right: 0;
            }

            li:nth-of-type(n + 5) {
                margin-top: 21px;
            }
        }

        li {
            margin-right: 24px;
            width: 64px;

            .iChat-tool-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;

                .joinBox {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    width: 64px;
                    height: 64px;
                    background-color: #f9fafc;
                    .icon-img {
                        width: 30px;
                        height: 30px;
                    }

                }

                .report-img-box{
                    display: flex;
                    align-items: center;
                    width: 64px;
                    height: 64px;
                    align-items: center;
                    justify-content: space-around;
                    background: #f9fafc;
                    img {
                        width: 28px;
                        height: 28px;
                    }
                }

                .icon-img {
                    height: 64px;
                    width: 100%;
                }

                .item-text {
                    margin-top: 8px;
                    line-height: 20px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #71747A;
                }

                .C_item-text {
                    color: #666666;
                }
            }

            .iChat-tool-item input[type='file'] {
                display: none;
            }
        }
    }

    .disable-text {
        color: #71747A;
        opacity: .5;
    }
</style>
